/* eslint-disable no-restricted-globals */
import { Box } from '@mui/material';
import React from 'react';
import './MackyLogo.css';

export type IMackyLogoProps = {};

const MackyLogo: React.FC<IMackyLogoProps> = ({}) => {
  return (
    <Box
      className="container"
    >
      <Box
        sx={{
          ':hover': {
            cursor: 'pointer',
          },
        }}
        onClick={() => { location.href = '/'; }}
      >
        <h3 className="Macky">Macky</h3>
      </Box>
    </Box>
  );
};

export { MackyLogo };
